import React from 'react';
import Criteria from 'components/Common/Pools/Criteria';
import IntlMessages from '@jumbo/utils/IntlMessages';

const NextRoundCriterias = ({ joinClaimConditionsInfo, activityPoolSettings }) => {
  const userBanned = !joinClaimConditionsInfo.noBanSatisfied;

  const criteria = [
    {
      text: (
        <div>
          <IntlMessages id={'component.careerPoints'} /> ({joinClaimConditionsInfo.nCareerPointsDiff}/
          {activityPoolSettings.careerPointsThreshold})
        </div>
      ),
      conditionMet: joinClaimConditionsInfo.careerPointsSatisfied,
    },
    {
      text: (
        <div>
          <IntlMessages id={'component.invitedUsers'} /> ({joinClaimConditionsInfo.nInvitedDiff}/
          {activityPoolSettings.invitedThreshold})
        </div>
      ),
      conditionMet: joinClaimConditionsInfo.invitedSatisfied,
    },
  ];

  return (
    <div>
      <h3>
        <IntlMessages id={'component.getReadyForNextRound'} />
      </h3>
      {!userBanned ? (
        criteria.map((criterion, index) => (
          <Criteria key={index} text={criterion.text} conditionMet={criterion.conditionMet} />
        ))
      ) : (
        <Criteria text={<IntlMessages id={'component.userNotApproved'} />} conditionMet={false} />
      )}
    </div>
  );
};

export default NextRoundCriterias;
